export default ({ COLORS, BREAKPOINTS }) => ({
  hintCell: {
    display: 'flex',
    fontSize: '12px',
    lineHeight: '14px',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  },
  hint: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '40px',
    '&:before': {
      content: '""',
      flexShrink: '0',
      height: '100%',
      width: '5px',
      backgroundColor: '#ececec',
      margin: '0 10px 0 0',
      borderRadius: '10px'
    },
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      height: 'auto',
      '&:before': {
        display: 'none'
      }
    }
  }
})
